export default __webpack_public_path__ + "static/media/fNeutral24.2ff30e7c.png";